import {filter, isEmpty} from 'ramda';

import {call} from 'redux-saga/effects';
import type {ActiveFilterType} from 'reducers/category/filters/filtersType';
import {getUrlParams} from 'libs/url';

/**
 * Convert active filters to query string
 * @param {ActiveFilterType} activeFilters - New active filters for URL
 * @returns {string} - Query string with active filters
 */
export function createUrlString(activeFilters: ActiveFilterType): string {
    const availableFilters = filter(item => !isEmpty(item), activeFilters);

    return Object.keys(availableFilters)
        .map(
            (attr: string) =>
                `${attr}=${availableFilters[attr]
                    .map((item): string => `${item.value}`)
                    .join(',')}`,
        )
        .join('&');
}

/**
 * Get url params without filters
 * @param {ActiveFilterType} activeFilters - Active filters
 * @returns {object} URL params without filters
 */
export function* urlParamsWithoutFilters(
    activeFilters: ActiveFilterType,
): {[string]: Array<{value: string}>} {
    const result = {};
    const currentParams = yield call(getUrlParams);
    Object.keys(currentParams).forEach((codeFilter: string) => {
        const isFilterFamily = Object.keys(activeFilters).includes(codeFilter);
        if (!isFilterFamily) result[codeFilter] = currentParams[codeFilter].map(value => ({value}));
    });
    return result;
}
